import "./Certs.css";

const certificates = [
  {
    title: "CCST Cybersecurity",
    description: "Cisco Certified Support Technician Cybersecurity",
    issuedBy: "Cisco",
    date: "2025 – 2030",
    link: "https://www.credly.com/badges/0f4f069f-1047-4700-9d2d-49f1963d1d5e/public_url",
    icon: `${process.env.PUBLIC_URL}/Images/cyber.png`,
  },
  {
    title: "CCST Networking",
    description: "Cisco Certified Support Technician Networking",
    issuedBy: "Cisco",
    date: "2025 – 2030",
    link: "https://www.credly.com/badges/ca8423e6-89e4-4a53-b275-bf446a6e75c0/public_url",
    icon: `${process.env.PUBLIC_URL}/Images/ccst.png`,
  },
  {
    title: "NSST",
    description: "Network Security Support Technician",
    issuedBy: "Pearson",
    date: "2025 – 2030",
    link: "https://www.credly.com/badges/eab7df12-b50b-4549-8894-291bcb9ad802/public_url",
    icon: `${process.env.PUBLIC_URL}/Images/nsst.png`,
  },
];



function Certificates() {
  return (
    <section id="certificates" className="certificates-section">
      <h2 className="certificates-title">Certificates</h2>

      <div className="certificates-row">
        {certificates.map((c, index) => (
          <div key={index} className="certificate-box">

            <a href={c.link} target="_blank" rel="noopener noreferrer">
              <div className="cert-image">
                <img src={c.icon} alt={c.title} />
              </div>
            </a>

            <p className="certificate-name">{c.title}</p>
            <p className="certificate-description">{c.description}</p>

            <p className="certificate-issuedBy">
              <span>Issued by:</span> {c.issuedBy}
            </p>

            <p className="certificate-date">{c.date}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Certificates;
